export type ArrowDirection = "left" | "right" | "up" | "down";
export type MediaAction = "play" | "rewind" | "forward";

function eventWhich(ev: KeyboardEvent): number {
  var withWhich = ev as KeyboardEvent & { which?: number };
  return ev.keyCode || withWhich.which || 0;
}

export function isTextEntry(el: HTMLElement | null): boolean {
  if (!el) return false;
  var tag = el.tagName;
  if (tag === "TEXTAREA") return true;
  if (el.getAttribute("contenteditable") === "true") return true;
  if (tag !== "INPUT") return false;
  var type = (el as HTMLInputElement).type;
  if (!type) return true;
  var t = type.toLowerCase();
  if (
    t === "button" ||
    t === "submit" ||
    t === "reset" ||
    t === "checkbox" ||
    t === "radio" ||
    t === "range" ||
    t === "file" ||
    t === "hidden" ||
    t === "image" ||
    t === "color"
  ) {
    return false;
  }
  return true;
}

export function isActivateKey(ev: KeyboardEvent): boolean {
  var which = eventWhich(ev);
  if (ev.key === "Enter" || which === 13) return true;
  if (ev.key === " " || ev.key === "Spacebar" || which === 32) return true;
  return false;
}

export function arrowDirection(ev: KeyboardEvent): ArrowDirection | "" {
  var key = ev.key;
  var which = eventWhich(ev);
  if (key === "ArrowLeft" || which === 37) return "left";
  if (key === "ArrowRight" || which === 39) return "right";
  if (key === "ArrowUp" || which === 38) return "up";
  if (key === "ArrowDown" || which === 40) return "down";
  return "";
}

/** بازگشت ریموت: Escape، Backspace خارج از فیلد متن، اندروید، وب‌اواس و تایزن. */
export function isBackKey(ev: KeyboardEvent, el: HTMLElement | null): boolean {
  var which = eventWhich(ev);
  if (which === 8 || ev.key === "Backspace") {
    return !isTextEntry(el);
  }
  if (which === 27 || ev.key === "Escape") return true;
  if (which === 4 || which === 166 || which === 461 || which === 10009) return true;
  if (ev.key === "Back" || ev.key === "GoBack" || ev.key === "BrowserBack" || ev.key === "XF86Back") {
    return true;
  }
  return false;
}

export function mediaAction(ev: KeyboardEvent): MediaAction | "" {
  var which = eventWhich(ev);
  if (which === 179) return "play";
  if (which === 227) return "rewind";
  if (which === 228) return "forward";
  return "";
}
